export default __webpack_public_path__ + "static/media/rarity-rate-kat4.885c5c6f.svg";